import type { App } from 'vue'
import { useUserStore } from '@/store/modules/user'

// 修复：移除模块顶层的 useI18n 调用 - 2025-11-23
// const { t } = useI18n() // 国际化

/** 判断权限的指令 directive */
export function hasPermi(app: App<Element>) {
  app.directive('hasPermi', (el, binding) => {
    const { value } = binding

    if (value && value instanceof Array && value.length > 0) {
      const hasPermissions = hasPermission(value)

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      // 修复：在函数内部获取 i18n - 2025-11-23
      const { t } = useI18n()
      throw new Error(t('permission.hasPermission'))
    }
  })
}

/** 判断权限的方法 function */
const all_permission = '*:*:*'
export const hasPermission = (permission: string[]) => {
  // 修复：在函数内部获取 store，避免在 Pinia 初始化前调用 - 2025-11-23
  const userStore = useUserStore()
  return (
    userStore.permissions.has(all_permission) ||
    permission.some((permission) => userStore.permissions.has(permission))
  )
}
